import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@supoui/core/services/http.service';
import { Ticket } from '@supoui/shared/model/Ticket';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TableauService {
  constructor(private httpService: HttpService) {}

  public getTicket(profileCode: string): Observable<string> {
    return this.httpService.get<Ticket>(`services/supo-ui/api/tableau/ticket/${profileCode}`).pipe(map(response => response.ticket));
  }
}
